import {
  LIVE_BYTES_ADDED_EVENT,
  LIVE_BYTES_DELETED_EVENT,
  LIVE_BYTES_EDITED_EVENT,
  LIVE_BYTES_RECONNECT_EVENT
} from '@/components/_layout/ASidebar/LiveBytes/enums'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      liveBytes: 'liveBytes/liveBytesItems'
    })
  },
  methods: {
    ...mapMutations({
      setLiveBytes: 'liveBytes/SET_LIVE_BYTES_ITEMS'
    }),
    ...mapActions({
      requestGetLiveBytes: 'liveBytes/requestGetLiveBytes'
    }),
    $_liveBytes_handleLiveBytesAdded(liveBytes) {
      if (!liveBytes) return

      try {
        const currentLiveBytes = this.liveBytes
        const updatedLiveBytes = [
          ...liveBytes.map(liveByte => ({ ...liveByte, isNew: true })),
          ...currentLiveBytes
        ]

        this.setLiveBytes(updatedLiveBytes)
      } catch (err) {
        console.error(err)
      }
    },
    $_liveBytes_handleLiveBytesEdited(liveBytes) {
      if (!liveBytes) return

      const currentLiveBytes = this.liveBytes
      const updatedLiveBytes = currentLiveBytes.map(liveByte => {
        const edited = liveBytes.find(
          editedLiveByte => editedLiveByte.Id === liveByte.Id
        )
        return edited ? { ...liveByte, ...edited } : liveByte
      })
      this.setLiveBytes(updatedLiveBytes)
    },
    $_liveBytes_handleLiveBytesReconnect() {
      this.requestGetLiveBytes()
    },
    $_liveBytes_handleLiveBytesDeleted(liveByteIds) {
      if (!liveByteIds) return

      const currentLiveBytes = this.liveBytes
      const updatedLiveBytes = currentLiveBytes.filter(
        liveByte => !liveByteIds.includes(liveByte.Id)
      )
      this.setLiveBytes(updatedLiveBytes)
    },
    async $_liveBytes_initializeLiveBytes() {
      try {
        await this.requestGetLiveBytes()
      } catch (err) {
        this.$errorHandler(err, this)
      }

      this.$bus.$on(
        LIVE_BYTES_ADDED_EVENT,
        this.$_liveBytes_handleLiveBytesAdded
      )
      this.$bus.$on(
        LIVE_BYTES_DELETED_EVENT,
        this.$_liveBytes_handleLiveBytesDeleted
      )
      this.$bus.$on(
        LIVE_BYTES_EDITED_EVENT,
        this.$_liveBytes_handleLiveBytesEdited
      )
      this.$bus.$on(
        LIVE_BYTES_RECONNECT_EVENT,
        this.$_liveBytes_handleLiveBytesReconnect
      )
    }
  },
  mounted() {
    this.$_liveBytes_initializeLiveBytes()
  },
  beforeDestroy() {
    this.$bus.$off(
      LIVE_BYTES_ADDED_EVENT,
      this.$_liveBytes_handleLiveBytesAdded
    )
    this.$bus.$off(
      LIVE_BYTES_DELETED_EVENT,
      this.$_liveBytes_handleLiveBytesDeleted
    )
    this.$bus.$off(
      LIVE_BYTES_EDITED_EVENT,
      this.$_liveBytes_handleLiveBytesEdited
    )
    this.$bus.$off(
      LIVE_BYTES_RECONNECT_EVENT,
      this.$_liveBytes_handleLiveBytesReconnect
    )
  }
}
